module.exports = __webpack_public_path__ + "img/amex.d34eef40.svg";